var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 577,
    viewBox: "0 0 745 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1674_80386)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1674_80386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 66,
    width: 577,
    height: 409,
    rx: 23.1816,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.761 115.735C135.253 115.735 139.706 111.283 139.706 105.791C139.706 100.298 135.253 95.8459 129.761 95.8459C124.269 95.8459 119.816 100.298 119.816 105.791C119.816 111.283 124.269 115.735 129.761 115.735Z",
    fill: "#FF080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.929 116.165C161.421 116.165 165.874 111.712 165.874 106.22C165.874 100.728 161.421 96.2756 155.929 96.2756C150.437 96.2756 145.984 100.728 145.984 106.22C145.984 111.712 150.437 116.165 155.929 116.165Z",
    fill: "#FF822A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.097 116.165C187.589 116.165 192.042 111.712 192.042 106.22C192.042 100.728 187.589 96.2756 182.097 96.2756C176.605 96.2756 172.152 100.728 172.152 106.22C172.152 111.712 176.605 116.165 182.097 116.165Z",
    fill: "#36C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M572.873 40.597V103.595C572.873 113.063 580.549 120.727 590.005 120.727H660.99",
    stroke: "#0C3A72",
    strokeWidth: 5.96915,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373.506 90.1768H452.705C462.172 90.1768 469.836 97.8531 469.836 107.308V158.965C469.836 168.432 477.512 176.097 486.967 176.097H585.423C594.89 176.097 602.554 183.773 602.554 193.228V255.665C602.554 265.133 594.878 272.797 585.423 272.797H572.947C563.48 272.797 555.816 280.473 555.816 289.928V326.101C555.816 335.569 563.492 343.233 572.947 343.233H660.992",
    stroke: "#0C3A72",
    strokeWidth: 5.96915,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373.506 418.731H459.39C468.857 418.731 476.521 411.054 476.521 401.599V326.937C476.521 317.47 484.198 309.806 493.653 309.806H555.816",
    stroke: "#0C3A72",
    strokeWidth: 5.96915,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M534.076 491.268V423.637C534.076 414.17 541.753 406.506 551.208 406.506H660.622",
    stroke: "#0C3A72",
    strokeWidth: 5.96915,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.506 226.739H500.123C509.59 226.739 517.255 219.063 517.255 209.608V176.097",
    stroke: "#0C3A72",
    strokeWidth: 5.96915,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.826 491.268V418.444",
    stroke: "#0C3A72",
    strokeWidth: 5.96915,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.907 177.291C526.907 182.565 522.631 186.841 517.357 186.841C512.082 186.841 507.806 182.565 507.806 177.291C507.806 172.016 512.082 167.74 517.357 167.74C522.631 167.74 526.907 172.016 526.907 177.291Z",
    fill: "#0C3A72",
    stroke: "#0C3A72",
    strokeWidth: 1.19383
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.108 309.806C565.108 315.08 560.832 319.356 555.558 319.356C550.283 319.356 546.007 315.08 546.007 309.806C546.007 304.531 550.283 300.255 555.558 300.255C560.832 300.255 565.108 304.531 565.108 309.806Z",
    fill: "#0C3A72",
    stroke: "#0C3A72",
    strokeWidth: 1.19383
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M635.546 121.181C635.546 126.455 631.27 130.731 625.995 130.731C620.721 130.731 616.445 126.455 616.445 121.181C616.445 115.906 620.721 111.63 625.995 111.63C631.27 111.63 635.546 115.906 635.546 121.181Z",
    fill: "#0C3A72",
    stroke: "#0C3A72",
    strokeWidth: 1.19383
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.37 418.444C437.37 423.719 433.094 427.995 427.819 427.995C422.545 427.995 418.269 423.719 418.269 418.444C418.269 413.169 422.545 408.893 427.819 408.893C433.094 408.893 437.37 413.169 437.37 418.444Z",
    fill: "#0C3A72",
    stroke: "#0C3A72",
    strokeWidth: 1.19383
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M544.815 459.034C544.815 464.309 540.539 468.585 535.265 468.585C529.99 468.585 525.714 464.309 525.714 459.034C525.714 453.76 529.99 449.484 535.265 449.484C540.539 449.484 544.815 453.76 544.815 459.034Z",
    fill: "#0C3A72",
    stroke: "#0C3A72",
    strokeWidth: 1.19383
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.249 207C332.4 207 300 239.4 300 279.249C300 319.098 332.4 351.498 372.249 351.498C412.098 351.498 444.498 319.098 444.498 279.249C444.126 239.4 412.098 207 372.249 207Z",
    fill: "#0B6BDD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.46 213.648V247.541C394.562 239.798 383.743 235.024 371.809 235.024C347.626 235.024 328.021 254.628 328.021 278.811C328.021 302.994 347.626 322.599 371.809 322.599C395.992 322.599 415.596 302.994 415.596 278.811L415.596 278.705V221.561C411.531 218.479 407.131 215.82 402.46 213.648ZM402.46 278.812V278.723C402.412 261.835 388.707 248.16 371.809 248.16C354.881 248.16 341.158 261.883 341.158 278.811C341.158 295.74 354.881 309.463 371.809 309.463C388.737 309.463 402.46 295.74 402.46 278.812Z",
    fill: "#0C3A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.771 309.773C396.662 315.883 388.881 320.049 380.409 321.746C371.937 323.443 363.153 322.595 355.161 319.31C347.17 316.025 340.329 310.45 335.5 303.285C330.67 296.121 328.069 287.687 328.022 279.047C327.976 270.407 330.486 261.946 335.238 254.73C339.99 247.514 346.77 241.865 354.725 238.494C362.681 235.123 371.456 234.181 379.946 235.786C388.435 237.392 396.26 241.473 402.436 247.517L393.248 256.905C388.925 252.675 383.447 249.818 377.505 248.694C371.562 247.57 365.419 248.229 359.851 250.589C354.282 252.949 349.535 256.903 346.209 261.954C342.883 267.006 341.126 272.928 341.158 278.976C341.191 285.024 343.012 290.928 346.392 295.943C349.773 300.958 354.562 304.861 360.156 307.161C365.75 309.46 371.899 310.053 377.829 308.865C383.759 307.677 389.206 304.761 393.483 300.485L402.771 309.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 84,
    y: 66,
    width: 289,
    height: 409,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1674_80386",
    x: 0,
    y: 0,
    width: 745,
    height: 577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1674_80386"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1674_80386"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1674_80386"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1674_80386",
    result: "effect2_dropShadow_1674_80386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1674_80386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1674_80386"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 66,
    width: 577,
    height: 409,
    rx: 23.1816,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.80028710273ef0067bba9b747230ad5c.svg";
export { ForwardRef as ReactComponent };